// src/components/LaunchTimeline.jsx
import React from "react";
import { CalendarCheck, Truck } from "lucide-react";

export default function LaunchTimeline() {
  return (
    <section className="py-16">
      <div className="max-w-4xl mx-auto text-center">

        {/* Header */}
        <h3 className="text-3xl sm:text-4xl font-bold mb-4 text-[var(--aerzen-black)]">
          A Clear & Honest Launch Timeline
        </h3>

        <p className="text-[var(--aerzen-black)]/70 max-w-2xl mx-auto mb-14">
          No vague promises. No hidden delays.  
          Just a transparent path from early access to delivery.
        </p>

        {/* Timeline */}
        <div className="grid md:grid-cols-2 gap-10">

          {/* Pre-Booking */}
          <div className="bg-white p-10 rounded-3xl shadow-xl border border-[var(--aerzen-silver)]/40">
            <div className="flex items-center justify-center mb-5">
              <CalendarCheck className="h-11 w-11 text-[var(--aerzen-blue)]" />
            </div>

            <h4 className="text-xl font-semibold mb-2">
              Early Access Pre-Booking Opens
            </h4>

            <p className="text-2xl font-bold text-[var(--aerzen-blue)] mb-4">
              15 January 2026
            </p>

            <p className="text-sm text-[var(--aerzen-black)]/70 leading-relaxed">
              Early Access allocation begins.  
              Pre-booking amount is fully adjustable against the final invoice.
            </p>
          </div>

          {/* Delivery */}
          <div className="bg-white p-10 rounded-3xl shadow-xl border border-[var(--aerzen-silver)]/40">
            <div className="flex items-center justify-center mb-5">
              <Truck className="h-11 w-11 text-[var(--aerzen-blue)]" />
            </div>

            <h4 className="text-xl font-semibold mb-2">
              Delivery Begins
            </h4>

            <p className="text-2xl font-bold text-[var(--aerzen-blue)] mb-4">
              01 May 2026 onwards
            </p>

            <p className="text-sm text-[var(--aerzen-black)]/70 leading-relaxed">
              Manufacturing, quality checks, and logistics completed  
              before dispatch to your home.
            </p>
          </div>
        </div>

        {/* Footer Note */}
        <p className="text-xs text-[var(--aerzen-black)]/50 mt-12 leading-relaxed">
          Timelines may shift slightly due to regulatory or logistics factors.  
          Customers will always be informed well in advance.
        </p>
      </div>
    </section>
  );
}
